(() => {
  if (window.voltaireStoryDisclosure) return;
  window.voltaireStoryDisclosure = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');

  function targetFromHash() {
    try { return document.getElementById(decodeURIComponent(location.hash.slice(1))); }
    catch { return null; }
  }

  function arrive(details, target, focus) {
    requestAnimationFrame(() => {
      if (!details.open || !details.isConnected) return;
      target.scrollIntoView({behavior: reduce.matches ? 'auto' : 'smooth', block: 'start'});
      if (focus) target.focus({preventScroll: true});
    });
  }

  function openHashTarget() {
    const target = targetFromHash();
    const details = target?.closest('[data-story-disclosure]');
    if (!details) return;
    if (details.open) arrive(details, target, false);
    else details.open = true;
  }

  function init(root = document) {
    root.querySelectorAll('[data-story-disclosure]').forEach(details => {
      if (details.dataset.storyReady) return;
      details.dataset.storyReady = 'true';
      const target = details.querySelector('[data-story-continuation]');
      const summary = details.querySelector('summary');
      const close = details.querySelector('[data-story-close]');
      if (!target || !summary || !close) return;
      close.hidden = false;
      details.addEventListener('toggle', () => {
        if (details.open) {
          // Give the expanded passage a shareable anchor without adding a navigation step.
          try { history.replaceState(history.state, '', '#' + target.id); } catch {}
          arrive(details, target, true);
        } else if (targetFromHash() === target) {
          try { history.replaceState(history.state, '', location.pathname + location.search); } catch {}
        }
      });
      close.addEventListener('click', () => {
        details.open = false;
        summary.focus({preventScroll: true});
        summary.scrollIntoView({behavior: reduce.matches ? 'auto' : 'smooth', block: 'center'});
      });
    });
    openHashTarget();
  }

  init();
  window.addEventListener('hashchange', openHashTarget);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
